module.exports = __webpack_public_path__ + "img/tudasbazis_gomb_aktiv.ab91957d.png";